<template>
  <main class="service-page">
    <header class="service-hero">
      <p class="brand">清北博雅 · 学员服务说明</p>
      <h1>学习服务反馈与处理说明</h1>
      <p class="lead">备考过程中，无论是知识点与题目疑问、学习节奏需要沟通，还是对服务体验有建议或不满意，您都可以通过身边已有的服务渠道及时反馈。我们希望让问题有入口、沟通有承接、处理有回应。</p>
      <div class="hero-note">群内可直接联系班主任、客服老师或其他服务老师；一对一沟通场景可直接联系班主任。页面公布邮箱为公开联系渠道之一，并非每次反馈都必须通过邮件提交。具体服务配置以所报班次为准。</div>
    </header>

    <div class="keypoints">
      <article class="key"><strong>学习疑问有入口</strong><p>知识点或题目疑问，可向答疑老师咨询；不确定找谁时，也可先联系群内老师协助衔接。</p></article>
      <article class="key"><strong>反馈方式更灵活</strong><p>可在服务群内反馈，也可与班主任一对一沟通；无需为了反馈而固定使用某一种渠道。</p></article>
      <article class="key"><strong>服务问题有承接</strong><p>对服务不满意或有改进建议，可向班主任、客服老师或群内服务老师提出，由相关老师跟进处理。</p></article>
    </div>

    <section class="service-section">
      <div class="section-head"><h2>遇到不同问题，可以先联系谁</h2><span class="sub">找到更适合的沟通入口</span></div>
      <div class="role-grid" style="display:grid;grid-template-columns:repeat(3,1fr);gap:14px;">
        <div class="role-card" v-for="r in roles" :key="r.mark"><span class="role-mark">{{ r.mark }}</span><h3>{{ r.title }}</h3><p>{{ r.desc }}</p></div>
      </div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>您可以通过哪些方式反馈</h2><span class="sub">不设置单一必经入口</span></div>
      <div class="route-grid" style="display:grid;grid-template-columns:repeat(3,1fr);gap:14px;">
        <div class="route-card" v-for="r in routes" :key="r.label"><span class="route-label">{{ r.label }}</span><b>{{ r.title }}</b><p>{{ r.desc }}</p></div>
      </div>
      <div class="channel-note" style="margin-top:14px;padding:13px 16px;border-radius:10px;background:#fcf9f8;border:1px dashed #e4cccf;color:#6d6062;font-size:14px;"><strong>说明：</strong>邮箱是便于对外公开的联系渠道，不是学员每次反馈的必经方式。日常学习与服务问题，可优先通过已有服务群或直接联系老师进行沟通。</div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>反馈与处理路径</h2><span class="sub">一般情况下可按以下方式沟通</span></div>
      <div class="steps-line steps-4">
        <article class="step"><div class="num">01</div><h3>提出疑问或反馈</h3><p>向答疑老师、班主任、客服老师或群内服务老师说明具体问题。</p></article>
        <article class="step"><div class="num">02</div><h3>确认问题类型</h3><p>根据内容判断属于学习答疑、节奏沟通，还是服务体验反馈。</p></article>
        <article class="step"><div class="num">03</div><h3>衔接相关老师</h3><p>如涉及其他服务环节，将根据实际情况进行转接、核实或协同跟进。</p></article>
        <article class="step"><div class="num">04</div><h3>沟通处理情况</h3><p>相关老师将结合具体事项与您进行说明，并反馈后续安排或处理情况。</p></article>
      </div>
    </section>

    <div class="two-col">
      <div class="card"><h2>为了便于沟通，您可说明</h2><ul class="items"><li>您所报课程或班次信息</li><li>问题属于学习答疑、进度沟通还是服务反馈</li><li>具体遇到的情况和希望获得的协助</li><li>如此前已沟通，可简要说明沟通情况</li></ul></div>
      <div class="card">
        <h2>服务处理说明</h2>
        <ul class="items"><li>学习疑问优先由相应答疑老师解答</li><li>学习计划和节奏问题可由班主任沟通协调</li><li>服务建议或不满意情况可向班主任或客服老师反馈</li></ul>
        <div class="calc"><strong>涉及具体权益或约定事项时</strong>如反馈涉及课程服务范围、协议权益、退费或其他需核查事项，将结合所报班次、实际服务情况及相关约定进行沟通处理。</div>
      </div>
    </div>

    <section class="service-section">
      <div class="section-head"><h2>公开联系邮箱</h2></div>
      <div class="email-panel" style="display:flex;align-items:center;justify-content:space-between;gap:28px;margin-top:22px;padding:24px 28px;border-radius:18px;background:#fbf1f2;border:1px solid #e8d0d3;">
        <div><h3 style="margin:0 0 7px;color:#61030d;font-size:19px;">需要通过邮件联系我们？</h3><p style="margin:0;color:#6d6062;font-size:14px;">如您希望通过邮件补充反馈内容，可发送至以下公开邮箱。群内和一对一反馈渠道仍可正常使用。</p></div>
        <a class="email-btn" href="mailto:A19946817192@163.com" style="flex:0 0 auto;display:inline-flex;align-items:center;padding:14px 20px;border-radius:12px;background:#8c0b18;color:#fff;text-decoration:none;font-size:17px;font-weight:700;">A19946817192@163.com</a>
      </div>
    </section>

    <section class="service-section faq">
      <div class="section-head"><h2>常见问题</h2></div>
      <details open><summary>课程中的知识点或题目不会，应该联系谁？</summary><p>知识点、题目和课程内容相关疑问，可优先联系答疑老师。如您暂时不清楚对应老师，也可先联系班主任或群内服务老师协助衔接。</p></details>
      <details><summary>学习进度跟不上，或者不知道怎么安排复习，应该联系谁？</summary><p>学习节奏、学习计划、看课安排以及日常执行方面的问题，可直接与班主任沟通。</p></details>
      <details><summary>对服务不满意，是否必须发送邮件反馈？</summary><p>不需要。您可以直接在服务群内联系班主任、客服老师或其他服务老师，也可以一对一联系班主任。邮箱是公开联系渠道之一，适合希望通过邮件补充说明的情况。</p></details>
      <details><summary>在群内联系到的不是负责该事项的老师，问题还能反馈吗？</summary><p>可以。您可先向群内老师说明问题，后续将结合事项类型协助衔接相应服务老师进行沟通处理。</p></details>
      <details><summary>每个班次的服务配置是否完全一样？</summary><p>不同课程或班次的服务内容、服务角色与沟通安排可能存在差异，具体以您所报班次及实际服务安排为准。</p></details>
      <div class="bottom-note"><strong>说明：</strong>本页面用于帮助学员了解学习疑问与服务反馈的一般沟通路径。具体班次配置、服务内容及涉及课程权益或协议事项的处理，以所报课程、实际服务安排及相关约定为准。</div>
    </section>
  </main>
</template>

<script>
export default {
  name: "FeedbackGuide",
  data() {
    return {
      roles: [
        { mark: "学习内容问题", title: "答疑老师", desc: "适用于知识点理解、题目解答、课程内容学习中的具体疑问。您可以直接提出问题，便于老师针对内容进行解答。" },
        { mark: "学习节奏问题", title: "班主任", desc: "适用于学习计划、进度安排、日常执行、看课节奏以及备考过程中的沟通与服务衔接问题。" },
        { mark: "服务体验反馈", title: "客服老师或班主任", desc: "如对服务体验有建议或不满意，可直接反馈。群内其他服务老师也可以接收您的问题并协助衔接处理。" },
      ],
      routes: [
        { label: "日常便捷入口", title: "在服务群内直接联系", desc: "在群内可直接联系班主任、客服老师或其他服务老师，说明学习疑问、服务意见或希望协助处理的事项。" },
        { label: "单独沟通入口", title: "与班主任一对一沟通", desc: "如希望单独说明情况，或需要沟通学习节奏与服务体验，可直接联系班主任进行反馈。" },
        { label: "公开联系入口", title: "通过邮箱联系我们", desc: "如您希望以邮件方式补充说明，或不便通过群内沟通，可通过页面公布的邮箱联系我们。" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/service-common.scss";
.service-hero {
  .lead { max-width: 775px; }
}
.role-card {
  padding: 22px 20px; border:1px solid #ead7d8; background:#fdfafa; border-radius:14px;
  h3 { margin: 0 0 7px; color: #61030d; font-size: 18px; }
  p { margin: 0; color: #6d6062; font-size: 14px; line-height: 1.72; }
}
.role-mark {
  display: inline-flex; align-items: center; padding: 3px 10px; margin-bottom: 10px;
  border-radius: 999px; color: #8c0b18; background: #f8e8ea; font-size: 12px; font-weight: 700;
}
.route-card {
  position: relative; padding: 21px 20px; border-radius: 14px; background: #fdfafa; border: 1px solid #ead7d8;
  b { display: block; color: #61030d; font-size: 17px; margin-bottom: 7px; }
  p { margin: 0; color: #6d6062; font-size: 14px; }
}
.route-label {
  display: inline-block; margin-bottom: 9px; padding: 4px 9px; border-radius: 6px;
  background: #f8e8ea; color: #8c0b18; font-size: 12px; font-weight: 700;
}
.email-btn:hover { background: #61030d; }
</style>
